// extracted by mini-css-extract-plugin
module.exports = {"title":"organizations-main_title__1k-to"};